import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';

const AdminAccountPage = ({ currentMenu, clickChangeMenu }) => {
    const [members, setMembers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showRoleModal, setShowRoleModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedRoleId, setSelectedRoleId] = useState('');
    
    // Search states
    const [searchQuery, setSearchQuery] = useState('');
    const [filterRoleId, setFilterRoleId] = useState('');

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const memberData = await AdminApi.getMemberList();
            setMembers(memberData);
            
            const roleData = await AdminApi.getRoles();
            setRoles(roleData);
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDelete = async (userId, username) => {
        if (window.confirm(`Bạn có chắc muốn xóa (hoặc chặn) tài khoản ${username}?`)) {
            try {
                await AdminApi.deleteMember(userId);
                fetchData();
            } catch (err) {
                alert("Lỗi khi xóa tài khoản");
            }
        }
    };

    const handleOpenRoleModal = (user) => {
        setSelectedUser(user);
        setSelectedRoleId(user.roleIds && user.roleIds.length > 0 ? user.roleIds[0] : '');
        setShowRoleModal(true);
    };

    const handleUpdateRole = async () => {
        if (!selectedRoleId) return;
        try {
            await AdminApi.updateMemberRole(selectedUser.userid, selectedRoleId);
            setShowRoleModal(false);
            fetchData();
        } catch (err) {
            alert("Lỗi khi cập nhật nhóm thành viên");
        }
    };

    const handleExport = () => {
        const filtered = getFilteredMembers();
        if (filtered.length === 0) {
            alert("Không có dữ liệu để xuất");
            return;
        }

        // Create CSV content (Excel compatible UTF-8 with BOM)
        let csvContent = "\uFEFF";
        csvContent += "Đăng nhập,Email,Tên thật,Nhóm thành viên,Trạng thái\n";
        
        filtered.forEach(item => {
            const rolesStr = (item.roles || []).join('; ');
            const statusStr = item.isBanned ? "Đã chặn" : "Hoạt động";
            csvContent += `"${item.username}","${item.email}","${item.fullName || 'N/A'}","${rolesStr}","${statusStr}"\n`;
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `Danh-sach-thanh-vien-${new Date().toISOString().slice(0, 10)}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const getFilteredMembers = () => {
        return members.filter(item => {
            const matchQuery = !searchQuery || 
                item.username?.toLowerCase().includes(searchQuery.toLowerCase()) || 
                item.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.fullName?.toLowerCase().includes(searchQuery.toLowerCase());
            
            const matchRole = !filterRoleId || (item.roleIds && item.roleIds.includes(parseInt(filterRoleId)));
            
            return matchQuery && matchRole;
        });
    };

    const filteredMembers = getFilteredMembers();

    return (
        <div className="social-box" style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', margin: '15px' }}>
            <h3 className="page-title" style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Quản lý Tài khoản (Thành viên)</h3>
            
            <div className="header" style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '18px', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <a className="btn btn-primary" href="#"
                       onClick={e => { e.preventDefault(); clickChangeMenu && clickChangeMenu('account-create'); }}>
                        <i className="icon-pencil" /> Tạo Tài khoản
                    </a>
                    <a className="btn" href="#" onClick={e => { e.preventDefault(); clickChangeMenu && clickChangeMenu('taikhoan-roles'); }}>
                        Nhóm thành viên
                    </a>
                </div>

                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginLeft: 'auto', flexWrap: 'wrap' }}>
                    <input
                        type="text"
                        placeholder="Tìm theo tên / email..."
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                        style={{ margin: 0, minWidth: '220px' }}
                    />
                    <select
                        value={filterRoleId}
                        onChange={e => setFilterRoleId(e.target.value)}
                        style={{ margin: 0, minWidth: '170px' }}
                    >
                        <option value="">-- Tất cả nhóm --</option>
                        {roles.map(r => (
                            <option key={r.roleid} value={r.roleid}>{r.rolename}</option>
                        ))}
                    </select>
                    <button className="btn" onClick={handleExport}>
                        <i className="icon-download-alt" /> Export Excel
                    </button>
                </div>
            </div>

            <div className="table-container">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>Đăng nhập</th>
                            <th>Email</th>
                            <th>Tên thật</th>
                            <th>Nhóm thành viên</th>
                            <th>Trạng thái</th>
                            <th width="300px">Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="6" className="text-center">Đang tải...</td></tr>
                        ) : filteredMembers.length === 0 ? (
                            <tr><td colSpan="6" className="text-center">Không tìm thấy thành viên nào</td></tr>
                        ) : (
                            filteredMembers.map((item) => (
                                <tr key={item.userid}>
                                    <td>{item.username}</td>
                                    <td>{item.email}</td>
                                    <td>{item.fullName || 'N/A'}</td>
                                    <td>
                                        {item.roles && item.roles.map(r => (
                                            <span key={r} className="label label-info" style={{ marginRight: '5px' }}>{r}</span>
                                        ))}
                                    </td>
                                    <td>
                                        {item.isBanned ? 
                                            <span className="label label-important">Đã chặn</span> : 
                                            <span className="label label-success">Hoạt động</span>
                                        }
                                    </td>
                                    <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                        <button className="btn btn-primary" style={{ marginRight: '5px' }}
                                                onClick={() => handleOpenRoleModal(item)}>
                                            <i className="icon-pencil" /> Nhóm thành viên
                                        </button>
                                        <button className="btn btn-danger"
                                                onClick={() => handleDelete(item.userid, item.username)}>
                                            <i className="icon-minus-sign" /> Xóa
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>


            {/* Role Update Modal */}
            {showRoleModal && (
                <div className="modal-backdrop" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="modal-content" style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '400px' }}>
                        <h4>Thay đổi nhóm thành viên: {selectedUser.username}</h4>
                        <div style={{ margin: '20px 0' }}>
                            <label>Chọn nhóm:</label>
                            <select 
                                className="span12" 
                                value={selectedRoleId} 
                                onChange={e => setSelectedRoleId(e.target.value)}
                                style={{ width: '100%' }}
                            >
                                <option value="">-- Chọn nhóm --</option>
                                {roles.map(r => (
                                    <option key={r.roleid} value={r.roleid}>{r.rolename}</option>
                                ))}
                            </select>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button className="btn" onClick={() => setShowRoleModal(false)}>Hủy</button>
                            <button className="btn btn-primary" onClick={handleUpdateRole}>Lưu thay đổi</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminAccountPage;
